import { useMerchant } from '@/entities/merchant';
import { shortId } from '@/entities/moderation';

/**
 * Merchant display name for the create-modal vendor row, resolved through
 * the cached merchant-detail query. Unresolved ids fall back to their short
 * form (same contract as the table's vendor cell).
 */
export function useVendorName(merchantId: string | null | undefined): string {
  const id = merchantId?.trim() ?? '';
  const { data: merchant } = useMerchant(id === '' ? undefined : id, id !== '');
  const name = merchant?.name?.trim() ?? '';
  if (name !== '') return name;
  return id !== '' ? shortId(id) : '—';
}
